export const en = {
  Active: 'Active',
  Account: 'Account',
  Action: 'Action',
  Add: 'Add',
  Administration: 'Administration',
  Agents: 'Agents',
  Author: 'Author',
  Body: 'Body',
  AI: 'AI',
  Cancel: 'Cancel',
  Chatbot: 'Chatbot',
  Collapse: 'Collapse',
  KnowledgeBase: 'Knowledge Base',
  KnowledgeBases: 'Knowledge Bases',
  KnowledgeBaseItems: 'Knowledge Base Items',
  Chatbots: 'Chatbots',
  Clone: 'Clone',
  Config: 'Config',
  Connectors: 'Connectors',
  Copy: 'Copy',
  CopyClipboard: 'Copy to Clipboard',
  Content: 'Content',
  Database: 'Database',
  Databases: 'Databases',
  Roles: 'Roles',
  Date: 'Date',
  Debug: 'Debug',
  Delete: 'Delete',
  DeleteMessage: 'Are you sure you want to delete?',
  Download: 'Download',
  Edit: 'Edit',
  Email: 'Email',
  Emails: 'Emails',
  EmailConnectors: 'Email Connectors',
  EmailSorters: 'Email Sorters',
  Execution: 'Execution',
  Executing: 'Executing',
  Execute: 'Execute',
  Expand: 'Expand',
  name: 'Name',
  Enabled: ' Enabled',
  Success: 'Success',
  'Email Inbox': 'Email Inbox',
  'Email Message': 'Email Message',
  'Email Messages': 'Email Messages',
  'Email processed successfully': 'Email processed successfully',
  Dashboard: 'Dashboard',
  Copied: 'Copied to clipboard!',
  'AI Model': 'AI Model',
  'AI Temperature': 'AI Temperature',
  'AI Max Tokens': 'AI Max Tokens',
  'AI Context': 'AI Context',
  'AI Account': 'AI Account',
  'AI Connector': 'AI Connector',
  'AI Connectors': 'AI Connectors',
  'Executions scheduler': 'Executions scheduler',
  'Mark Emails as Read': 'Mark Emails as Read',
  'Identify spam emails': 'Identify spam emails',
  'Forward Emails': 'Forward Emails',
  'Reply to Original Sender': 'Reply to Original Sender',
  'Dry Run': 'Dry Run',
  'Include Recommended Reply in Forwarded Email': 'Include Recommended Reply in Forwarded Email',
  'in preview mode': 'in preview mode',
  'Use custom chatbot content': 'Use custom chatbot content',
  'New task scheduler': 'New task scheduler',
  'Use custom email content': 'Use custom email content',
  'Custom Email Content': 'Custom Email Content',
  'Email Subject': 'Email Subject',
  'Email Content': 'Email Content',
  'Recur every days': 'Recur every days',
  'Include reply': 'Include Reply',
  'Set spam': 'Set spam',
  'Reply sender': 'Reply sender',
  'Mark as read': 'Mark as read',
  'Type Id': 'Type Id',
  'First name': 'First name',
  'Last name': 'Last name',
  From: 'From',
  Forward: 'Forward',
  forwardTo: 'Forward To',
  Hide: 'Hide',
  Home: 'Home',
  Kit: 'Kit',
  Kits: 'Kits',
  Needs: 'needs',
  Language: 'Language',
  Logs: 'Logs',
  Messages: 'Messages',
  Name: 'Name',
  now: 'now',
  Password: 'Password',
  Permissions: 'Permissions',
  Phone: 'phone',
  Preview: 'Preview',
  Process: 'Process',
  Results: 'Results',
  Reply: 'Reply',
  replyTo: 'Reply to',
  Robots: 'Robots',
  Robot: 'Robot',
  Options: 'Options',
  Role: 'Role',
  OneDrive: 'OneDrive',
  Running: 'Running',
  Run: 'Run',
  Search: 'Search',
  Schedule: 'Schedule',
  Scheduler: 'Scheduler',
  Show: 'Show',
  Start: 'Start',
  Subject: 'Subject',
  Storage: 'Storage',
  Stop: 'Stop',
  Submit: 'Submit',
  System: 'System',
  Tasks: 'Tasks',
  Task: 'Task',
  Test: 'Test',
  Theme: 'Theme',
  Thread: 'Thread',
  Threads: 'Threads',
  To: 'To',
  Type: 'Type',
  Yes: 'Yes',
  No: 'No',
  Update: 'Update',
  Upload: 'Upload',
  User: 'User',
  Users: 'Users',
  View: 'View',
  Recruiter: 'Recruiter',
  Recruiters: 'Recruiters',
  Resumes: 'Resumes',
  Resume: 'Resume',
  OneDrive: 'OneDrive',
  'OneDrive Share': 'OneDrive Share',
  'OneDrive Shares': 'OneDrive Shares',
  'Google Drive Share': 'GoogleDrive Share',
  'GoogleDrive Share': 'GoogleDrive Share',
  'GoogleDrive Shares': 'Google Drive Shares',
  'Google Drive': 'Google Drive',
  Retrieve: 'Retrieve',
  resume: 'resume',
  resumes: 'resumes',
  Server: 'Server',
  Servers: 'Servers',
  Error: 'Error',
  matchesCriteria: 'Matches Criteria',
  email: 'Email',
  phone: 'Phone',
  firstName: 'First Name',
  lastName: 'Last Name',
  birthDate: 'Birth Date',
  facebook: 'Facebook',
  twitter: 'Twitter',
  instagram: 'Instagram',
  linkedin: 'Linkedin',
  github: 'Github',
  website: 'Website',
  interests: 'Interests',
  address: 'Address',
  city: 'City',
  gender: 'Gender',
  nativeLanguage: 'Native Language',
  skills: 'Skills',
  experience: 'Experience',
  education: 'Education',
  potentialJobTitles: 'Potential Job Titles',
  seniorityLevel: 'Seniority Level',
  jobChangeFrequency: 'Job Change Frequency',
  yearsOfExperience: 'Years Of Experience',
  containsPhoto: 'Contains Photo',
  matchingPercentage: 'Matching Percentage',
  explanation: 'Explanation',
  URL: 'URL',
  'URL Connector': 'URL Connector',
  'URL Connectors': 'URL Connectors',
  'Manage URLs': 'Manage URLs',
  'Start Crawl': 'Start Crawl',
  'Refresh Status': 'Refresh Status',
  Status: 'Status',
  Crawling: 'Crawling',
  Ready: 'Ready',
  'Last Crawl': 'Last Crawl',
  'URLs Crawled': 'URLs Crawled',
  'URLs Selected': 'URLs Selected',
  Never: 'Never',
  'Batch Actions': 'Batch Actions',
  'Select All Checked': 'Select All Checked',
  'Deselect All Checked': 'Deselect All Checked',
  'items selected': 'items selected',
  'Search URLs, titles, descriptions...': 'Search URLs, titles, descriptions...',
  Search: 'Search',
  Title: 'Title',
  Description: 'Description',
  'Crawl Time': 'Crawl Time',
  Action: 'Action',
  'N/A': 'N/A',
  'Please select at least one URL': 'Please select at least one URL',
  'Selected URLs have been marked as selected': 'Selected URLs have been marked as selected',
  'Selected URLs have been marked as deselected': 'Selected URLs have been marked as deselected',
  'Failed to update some URLs': 'Failed to update some URLs',
  'Select all on current page': 'Select all on current page',
  'Select all filtered results': 'Select all filtered results',
  'Select all data': 'Select all data',
  'This operation would select all filtered results across all pages': 'This operation would select all filtered results across all pages',
  'Loading all IDs...': 'Loading all IDs...',
  'Loading filtered IDs...': 'Loading filtered IDs...',
  'Selected all {{count}} items': 'Selected all {{count}} items',
  'Selected all {{count}} filtered items': 'Selected all {{count}} filtered items',
  'No items to select': 'No items to select',
  'No items match the filter': 'No items match the filter',
  'No filter applied': 'No filter applied',
  'Failed to get all IDs': 'Failed to get all IDs',
  'View Content': 'View Content',
  'Page Content': 'Page Content',
  'No content available': 'No content available',
  'Loading content...': 'Loading content...',
  'Refresh Content': 'Refresh Content',
  'Refreshing content for {{count}} pages...': 'Refreshing content for {{count}} pages...',
  'Content refreshed for {{count}} pages': 'Content refreshed for {{count}} pages',
  'Error refreshing some pages': 'Error refreshing some pages',
  'Unable to fetch page content. The server may need to recrawl this URL.': 'Unable to fetch page content. The server may need to recrawl this URL.',
  'Error loading content': 'Error loading content',
  Close: 'Close',
  ResetToPending: 'Reset to Pending',
  ResetItemsTooltip: 'Reset selected items back to pending status for reprocessing',
  PleaseSelectItemsToReset: 'Please select items to reset',
  ErrorResettingItems: 'Error resetting items',
  ItemsResetSuccessfully: 'Items reset successfully',
  'Indexing Status': 'Indexing Status',
  'Text Size': 'Text Size',
  Tokens: 'Tokens',
  'Indexed At': 'Indexed At',
  'Knowledge Base Information': 'Knowledge Base Information',
  'Last Indexed': 'Last Indexed',
  'Token Count': 'Token Count',
  'OpenAI Storage': 'OpenAI Storage',
  Licitatii: 'Auctions',
  'Centralizator Licitatii': 'Auctions Hub',
  Refresh: 'Refresh',
  Licitatie: 'Auction',
  'Fetch SEAP': 'Fetch SEAP',
  'Email Office365': 'Email Office365',
  'Emails Office365': 'Emails Office365',
  'ERP': 'ERP',
  'ERP Connectors': 'ERP Connectors',
  'ERP Connector': 'ERP Connector',
}
